import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/lib/api";
import { StatusBadge, RefPill } from "@/components/StatusBadge";
import { Lock } from "lucide-react";

export const RecordsTable = ({ items, empty = "No records found." }) => {
  const nav = useNavigate();
  const { meta } = useAuth();
  if (!items.length) return <div className="p-10 text-center text-sm text-slate-500" data-testid="records-empty">{empty}</div>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="records-table">
        <thead>
          <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200 bg-slate-50/80">
            <th className="px-4 py-2.5 font-semibold">Reference</th>
            <th className="px-4 py-2.5 font-semibold">Title</th>
            <th className="px-4 py-2.5 font-semibold hidden md:table-cell">Type</th>
            <th className="px-4 py-2.5 font-semibold">Status</th>
            <th className="px-4 py-2.5 font-semibold hidden lg:table-cell">Updated</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.record_id} onClick={() => nav(`/records/${r.record_id}`)} data-testid={`record-row-${r.record_id}`}
              className="border-b border-slate-100 hover:bg-slate-50 cursor-pointer transition-colors">
              <td className="px-4 py-3"><RefPill value={r.ref_no} /></td>
              <td className="px-4 py-3 max-w-md">
                <div className="font-medium text-slate-900 truncate flex items-center gap-1.5">{r.locked && <Lock className="w-3 h-3 text-slate-400 shrink-0" />}{r.title}</div>
                {r.office && r.office !== "main" && <div className="text-[11px] font-semibold text-sky-800" data-testid={`row-office-${r.record_id}`}>{meta.offices.find((o) => o.id === r.office)?.name || "Committee"}</div>}
                {r.tags?.length > 0 && <div className="text-[11px] text-slate-500 truncate">{r.tags.map((t) => `#${t}`).join(" ")}</div>}
              </td>
              <td className="px-4 py-3 hidden md:table-cell text-slate-600 whitespace-nowrap">{meta.record_types[r.record_type]?.label.split(" /")[0]}</td>
              <td className="px-4 py-3"><StatusBadge status={r.status} testid={`row-status-${r.record_id}`} /></td>
              <td className="px-4 py-3 hidden lg:table-cell text-slate-500 whitespace-nowrap">{fmtDate(r.updated_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
